import PageLayout from 'pages/InstructorViewAssignmentFeedback/PageLayout';
import PageProvider from 'pages/InstructorViewAssignmentFeedback/PageProvider';

const InstructorViewAssignmentFeedbackPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorViewAssignmentFeedbackPage;
